module.exports = __webpack_public_path__ + "static/img/img_live.26d2510b.png";